import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject,Subscription,takeUntil } from 'rxjs';
import { HhsgSharedEllipseSelectOption, HhsgSharedUserProfile } from '../../../models';
import { HHSGSharedNotificationDetails } from '../../../models/notification-details.model';
import { HhsgSharedConfigService, HhsgSharedLoadingService, HhsgSharedUserService } from '../../../services';
import { HhsgSharedNotificationService } from '../../../services/notification-service';
import { Constants } from '../../../utilities/constants.util';
import { RoleUtil } from '../../../utilities/role.util';
import { HhsgSharedApplication } from '../../../models/application.model';
import { formatDate,Location  } from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import { HhsgSharedEllipsesControlComponent } from '../../common/ellipses-control/ellipses-control.component';

@Component({
  selector: 'hhsg-notification-admin',
  templateUrl: './notification-admin.component.html',
  styleUrls: ['./notification-admin.component.scss']
})

export class HhsgSharedNotificationAdminComponent implements OnInit,OnDestroy {
	@ViewChild('ellipsesMenu') ellipsesMenu: HhsgSharedEllipsesControlComponent;
  	@Input() showBreadCrumb: boolean = false;

	isSelectAll: boolean = false;
	notificationDetails: any[];
	notifications: HHSGSharedNotificationDetails[];
	updateNotifications: HHSGSharedNotificationDetails[];
	selectedNotification: HHSGSharedNotificationDetails;
	notificationForm: UntypedFormGroup;
	confirmDelete: boolean = false;
	formBuilder: UntypedFormBuilder;
	form:UntypedFormGroup;
	private user = new HhsgSharedUserProfile();
	private _unsubscribe$ = new Subject<void>();
	fromHuronAccelerator:string = Constants.FromHuronAccelerators;
	notificationDateFormat : string='';
	toggleEllipse : boolean=false;
    activeApplicationId : number;
	applicationIdSubscription : Subscription;
	showAddNotification:boolean=false;
    activeApplications: HhsgSharedApplication[] = [];
	applicationAbbreviation :string;
	routeId:number;
	ellipsesMenuItems: HhsgSharedEllipseSelectOption[] = [];
	deleteMenuItemText: string = 'Delete';
	readMenuItemText: string = 'Mark as Read';
	messages: string[];
	hasErrorMessages: boolean;

	private _showDeleteButton: boolean = false;

	get showDeleteButton(): boolean {
	return this._showDeleteButton;
	}

	set showDeleteButton(value: boolean) {
		this._showDeleteButton = value;
		this.ellipsesMenu?.changeMenuItemEnabled(this.deleteMenuItemText, value);
	}

	private _showReadButton: boolean = false;
	get showReadButton(): boolean {
		return this._showReadButton;
	}
	set showReadButton(value: boolean) {
		this._showReadButton = value;
		this.ellipsesMenu?.changeMenuItemEnabled(this.readMenuItemText, value);
	}

  constructor(
	public configService: HhsgSharedConfigService,
    public _notificationService: HhsgSharedNotificationService,
	private route: ActivatedRoute,
	private _formBuilder:UntypedFormBuilder,
	private _userService: HhsgSharedUserService,
	private _loadingService: HhsgSharedLoadingService,
	private _location: Location,
	private router: Router)  {
	  	this.applicationAbbreviation = configService.appSettings.applicationAbbreviation;
	  	this.form = this._formBuilder.group({
        	selectAllcheckbox:[false],
        	selectCheckBox:[false]
		});
		let navigationCurrent = this.router.getCurrentNavigation();
		if( navigationCurrent && navigationCurrent.extras &&
			navigationCurrent.extras.state &&
			navigationCurrent.extras.state["id"]){
			this.routeId = navigationCurrent.extras.state["id"];
		}

	}

  	async ngOnInit(): Promise<void> {
      this.showBreadCrumb = this.showBreadCrumb || this.route.snapshot.data.showBreadCrumb;

      this._userService.getUserProfile()
		.pipe(takeUntil(this._unsubscribe$))
		.subscribe((user: HhsgSharedUserProfile) => {
			this.user = user;
			this.loadNotificationDetails();
		});

		this.showAddNotification = this.hasAdminPrivileges();
		this.setEllipsesMenuItems();
		this.route.queryParams.subscribe(params => {
			if (params && params.showSuccess && params.showSuccess === 'true') {
				this.addMessageBarMessage(Constants.SaveSuccessNotification, false);
			  this._location.replaceState('/notifications');
		  }
	  });
  	}

	public addMessageBarMessage(message: string, isError: boolean): void {
		this.messages = [message];
		this.hasErrorMessages = isError;
	}

 	async loadNotificationDetails() {
		if(!this.user || !this.user.userId) {
			return;
		}

		this._loadingService.setLoading(true);
   		await this._notificationService.getNotificationDetails(this.user.userId, this.applicationAbbreviation,true).then(response => {
			if (response.length > 0) {
				this.notifications = response;
				if(!this.selectedNotification?.notificationId){
					this.selectedNotification = this.notifications[0];
				}
				this._notificationService.announceNotificationCount(this.notifications.filter(s => !s.isRead).length);
				this.showDeleteButton=true;
				this.showReadButton=false;
			}
			else{
				this.notifications = this.selectedNotification = null;
				this.showDeleteButton=false;
				this.showReadButton=false;
			}
			if(this.routeId){
				setTimeout(()=>{
					this.onSelect(this.routeId,true);
					let element = document.getElementById("notification-"+this.routeId);
					this.scroll(element);
				},50);
				setTimeout(()=>{
					this._loadingService.setLoading(false);
				},2000);
			}
			else{
				this._loadingService.setLoading(false);
			}

		});
		this.form = this._formBuilder.group({
			selectAllcheckbox:[false],
			selectCheckBox:[false]
		});
	}

	async onSelect(notificationId: number,isRedirected:boolean) {
		this.selectedNotification = this.notifications?.find(n => n.notificationId == notificationId);
		this.updateNotifications = this.notifications?.filter(n => n.notificationId == notificationId && !n.isRead);
		await this.updateNotification(isRedirected);
	}

	convertMessage(message: any) {
		var tempDivElement = document.createElement("div");
		tempDivElement.innerHTML = message;
		return tempDivElement.textContent || tempDivElement.innerText || "";
	}


	selectAll() {
		this.isSelectAll = this.form.get('selectAllcheckbox').value;
		this.notifications.map(n => {
			n.isSelected = this.isSelectAll;
		})
		this.notificationGrayedOut();
	}

	notificationSelected(Id: number) {
		const checked = this.form.get('selectCheckBox').value;
		this.notifications?.map(n =>{
			if(n.notificationId==Id){
				n.isSelected=checked;
			}
		})
		this.notificationGrayedOut();
	}

	toggleNotificationPopover() {
		this.toggleEllipse = !this.toggleEllipse;
		this.notificationGrayedOut();
	}

	async maskAsRead() {
		this.updateNotifications =  this.notifications?.filter(n => n.isSelected && !n.isRead);
		await this.updateNotification(false);
		this.isSelectAll = false;
		this.notifications?.map(n=>{ n.isSelected=false; })
		this.toggleEllipse = false;
		this.showReadButton=false;
	}

 	async updateNotification(isRedirected:boolean) {
		var updateRecords = this.unreadNotifications;
		if (updateRecords == null || updateRecords.length == 0) {
			return;
		}
		this._loadingService.setLoading(true);
		await this._notificationService.updateNotificationDetails(updateRecords)
		.then(async (result) => {
			this.updateNotifications = null;
			this.loadNotificationDetails();
		},
		(error) => {
			this.addMessageBarMessage(error.error, true);
		});
		if(!isRedirected){
			this._loadingService.setLoading(false);
		}
	}

	onDeleteclick(){
		this.toggleEllipse = false;
		if(this.notifications?.some(n=>n.isSelected)){
			this.confirmDelete = true;

		}
	}

	deleteNotifications() {
		this.deleteNotificationDetails();
		this.isSelectAll = false;
		this.showReadButton=false;
	}

	async deleteNotificationDetails() {
		var deleteNotifications = this.notifications?.filter(n => n.isSelected);
		this.confirmDelete = false;
		//-- Reset any errors from previous operations
		if(deleteNotifications){
			this._loadingService.setLoading(true);
			await this._notificationService.deleteNotificationDetails(deleteNotifications)
			.then((result) => {
				let selectedDeleted=deleteNotifications.find(t=>t.notificationId==this.selectedNotification.notificationId);
                if(selectedDeleted){
                    this.selectedNotification = new HHSGSharedNotificationDetails();
                }
				this.loadNotificationDetails();
			},
				(error) => {
					this.addMessageBarMessage(error.error, true);
				});
				this._loadingService.setLoading(false);
		}
	}

	public hasAdminPrivileges(): boolean {
        if (!this.user) {
            return false;
        }
        return RoleUtil.isHuronAdmin(this.user.roles) || this.user.isRootAdmin;
    }

	ngOnDestroy(){
		if(this.applicationIdSubscription){
			this.applicationIdSubscription.unsubscribe();
		}
		this._unsubscribe$.next();
		this._unsubscribe$.complete();
	}

	getDateFormat(date:Date){
	    var currentDate= new Date();
		var givenDate=new Date(date);
		if(formatDate(givenDate,'yyyy-MM-dd','en_US') >= formatDate(currentDate,'yyyy-MM-dd','en_US'))
			return  this.notificationDateFormat = Constants.NotificationDateTimeFormat;
		else
			return  this.notificationDateFormat = Constants.NotificationDateFormat;
    }

	notificationGrayedOut(){
		var notificationGrayedOut=this.notifications?.filter(n => n.isSelected && !n.isRead);
		if(notificationGrayedOut?.length==0 || !(this.showDeleteButton)){
			this.showReadButton=false;
		}
		else{
			this.showReadButton=true;
		}
	}

	private get unreadNotifications(): HHSGSharedNotificationDetails[] {
		return this.updateNotifications?.filter(n => !n.isRead);
	}
	scroll(el: HTMLElement) {
		el.scrollIntoView({block: "center", inline: "nearest"});
	}
	generateNotificationId(id:number){
		return "notification-"+id;
	}

	setEllipsesMenuItems() {
		if (this.showAddNotification) {
			this.ellipsesMenuItems.push(new HhsgSharedEllipseSelectOption('New Notification', true));
		}
		this.ellipsesMenuItems.push(new HhsgSharedEllipseSelectOption(this.readMenuItemText, this.showReadButton));
		this.ellipsesMenuItems.push(new HhsgSharedEllipseSelectOption(this.deleteMenuItemText, this.showDeleteButton));
	}
	  
 	public onEllipsisButtonClicked(selectedOption: string): void {
		if (selectedOption == 'New Notification') {
			this.router.navigate(['/', 'admin','notifications','compose']);
		} 
		if (selectedOption == this.readMenuItemText) {
		this.maskAsRead();
		} 
		if (selectedOption == 'Delete') {
		this.onDeleteclick();
		}
	}
}
